import script from "./BodySubWhenIsUseful.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubWhenIsUseful.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubWhenIsUseful.vue?vue&type=style&index=0&id=09adfa3a&module=bodySubWhy&lang=css"
cssModules["bodySubWhy"] = style0
import "./BodySubWhenIsUseful.vue?vue&type=style&index=1&id=09adfa3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-09adfa3a"]])

export default __exports__